exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UserControls__controls___1XqPT {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.UserControls__controls___1XqPT > * {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.UserControls__controls___1XqPT > *:last-child {\n  margin-left: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"controls": "UserControls__controls___1XqPT"
};